function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19 9.21094C19 11.5897 17.8135 13.6913 16 14.9562V22.2109H13.4142L12 20.7967L10.5858 22.2109H8V14.9562C6.18652 13.6913 5 11.5897 5 9.21094C5 5.34494 8.13401 2.21094 12 2.21094C15.866 2.21094 19 5.34494 19 9.21094ZM17 9.21094C17 11.9724 14.7614 14.2109 12 14.2109C9.23858 14.2109 7 11.9724 7 9.21094C7 6.44951 9.23858 4.21094 12 4.21094C14.7614 4.21094 17 6.44951 17 9.21094ZM10 19.9682L12 17.9683L14 19.9683V15.9211C13.3663 16.1097 12.695 16.2109 12 16.2109C11.305 16.2109 10.6337 16.1097 10 15.9211V19.9682Z",
  fill: "#4979C0"
});

var SvgStatus = function SvgStatus(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStatus, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/status.f61b33c4.svg";
export { ForwardRef as ReactComponent };